import { getLocationSearch, isIosOrA } from "@/utils/utils";
import {
  DEFAULT_STYLE,
  HOST_CONFIG,
  TENANT_CONFIG,
  SPECIAL_STYLES,
  COMPANY_CONFIG,
  APP_DOWNLOAD_CONFIG,
  FLOW_MAP
} from "./constants";
import hhinviteImg from "@/assets/images/hhinvite.jpg";

/**
 * 配置管理类
 * 负责根据当前域名和租户标签获取对应的配置信息
 */
class ConfigManager {
  constructor() {
    this.host = window?.location?.host || "";
    this.tenantTag = getLocationSearch().tenantTag;
    this.hostConfig = this._getHostConfig();
    this.tenantConfig = this._getTenantConfig();
  }

  /**
   * 获取主机配置
   * @returns {Object} 主机配置对象
   */
  _getHostConfig() {
    const hostKey = Object.keys(HOST_CONFIG).find(key => this.host.includes(key));
    if (!hostKey) {
      return {
        img: "",
        title: "当前平台",
        tel: "",
        isJbx: false,
        isYW: false
      };
    }

    const config = { ...HOST_CONFIG[hostKey] };
    
    // 处理租户覆盖配置
    if (config.tenantOverrides && config.tenantOverrides[this.tenantTag]) {
      const override = config.tenantOverrides[this.tenantTag];
      Object.assign(config, override);
    }

    // 特殊处理悦道约达
    if (hostKey === "ydyx-h5" && this.tenantTag === "ydyd") {
      config.title = "悦道约达";
    }

    return config;
  }

  /**
   * 获取租户配置
   * @returns {Object} 租户配置对象
   */
  _getTenantConfig() {
    return TENANT_CONFIG[this.tenantTag] || {
      name: "",
      invite: hhinviteImg
    };
  }

  /**
   * 获取样式配置
   * @returns {Object} 样式配置对象
   */
  getStyle() {
    return Object.keys(TENANT_CONFIG).reduce((acc, key) => {
      acc[key] = SPECIAL_STYLES[key] || DEFAULT_STYLE;
      return acc;
    }, {});
  }

  // Getter 方法
  get logoImg() {
    return this.hostConfig.img;
  }

  get title() {
    return this.hostConfig.title;
  }

  get tel() {
    return this.hostConfig.tel;
  }

  get cxName() {
    return this.tenantConfig.name;
  }

  get inviteImg() {
    return this.tenantConfig.invite;
  }

  get isJbx() {
    return this.hostConfig.isJbx || false;
  }

  get isYW() {
    return this.hostConfig.isYW || false;
  }
}

// 创建配置实例
const configManager = new ConfigManager();

/**
 * 应用下载功能
 * 根据租户和平台跳转到对应的下载链接
 */
export const appDownload = () => {
  const tenant = getLocationSearch().tenantTag;
  const platform = isIosOrA() ? 'android' : 'ios';
  const url = APP_DOWNLOAD_CONFIG[platform]?.[tenant];
  
  if (url) {
    window.location.href = url;
  }
};

/**
 * 获取隐私政策中的开发者信息
 * @returns {string} 公司名称
 */
export const privacyChangeDev = () => {
  const tenantTag = getLocationSearch().tenantTag;
  return COMPANY_CONFIG[tenantTag]?.name || "当前平台";
};

/**
 * 获取开发者邮箱
 * @returns {string} 邮箱地址
 */
export const emailChangeDev = () => {
  const tenantTag = getLocationSearch().tenantTag;
  return COMPANY_CONFIG[tenantTag]?.email || "";
};

/**
 * 获取流程类型名称
 * @returns {string} 流程名称
 */
export const flowType = () => {
  const flowName = getLocationSearch().flowTag;
  return FLOW_MAP[flowName] || "";
};

// 导出配置对象
export default {
  HOST: configManager.host,
  LOGO_IMG: configManager.logoImg,
  TITLE: configManager.title,
  TEL: configManager.tel,
  CX_NAME: configManager.cxName,
  STYLE: configManager.getStyle(),
  inviteImg: configManager.inviteImg,
  isJbx: configManager.isJbx,
  isYW: configManager.isYW,
  
  // 导出函数
  appDownload,
  privacyChangeDev,
  emailChangeDev,
  flowType
};
